export interface InfiniteListItemWidth {
  md?: string;
  lg?: string;
  sm?: string;
  xs?: string;
}
